/**
 * Prop option UI for <product-form-custom> — swatch / label active state.
 * Same contract as assets/legacy/product-form-prop-ui.js:
 * native label→radio change only (no click preventDefault).
 */
(() => {
  'use strict';

  const SELECTOR_ROOT = 'product-form-custom';
  const SELECTOR_PROP_INPUT = '[data-value-type]';
  const SELECTOR_COLOR_LABEL = '[data-color-label]';
  const ATTR_DATA_VALUE_TYPE = 'data-value-type';
  const ATTR_DATA_VALUE = 'data-value';
  const ATTR_DATA_COLOR_VALUE = 'data-color-value';
  const CLASS_SWATCH_ACTIVE = 'swatch-active';
  const NS = '.productFormPropUi';

  function setActiveForInput(root, input) {
    if (!root || !input) return;
    const $root = $(root);
    const $input = $(input);
    const prop = String($input.attr(ATTR_DATA_VALUE_TYPE) || '').trim();
    const inputId = $input.attr('id');
    const value = $input.attr(ATTR_DATA_VALUE);
    if (!prop) return;

    $root.find(`[${ATTR_DATA_VALUE_TYPE}="${prop}"]`).each(function () {
      const id = $(this).attr('id');
      const v = $(this).attr(ATTR_DATA_VALUE);
      if (id) {
        $root.find(`label[for="${id}"]`).removeClass(CLASS_SWATCH_ACTIVE);
        $root.find(`${SELECTOR_COLOR_LABEL}[for="${id}"]`).removeClass(CLASS_SWATCH_ACTIVE);
      }
      if (prop === 'color' && v) {
        $root.find(`${SELECTOR_COLOR_LABEL}[${ATTR_DATA_COLOR_VALUE}="${v}"]`).removeClass(CLASS_SWATCH_ACTIVE);
      }
    });

    if (inputId) {
      $root.find(`label[for="${inputId}"]`).addClass(CLASS_SWATCH_ACTIVE);
      $root.find(`${SELECTOR_COLOR_LABEL}[for="${inputId}"]`).addClass(CLASS_SWATCH_ACTIVE);
    }
    if (prop === 'color' && value) {
      $root.find(`${SELECTOR_COLOR_LABEL}[${ATTR_DATA_COLOR_VALUE}="${value}"]`).addClass(CLASS_SWATCH_ACTIVE);
    }
  }

  function bind(root) {
    if (!root || root.dataset.propUiBound === 'true') return;
    root.dataset.propUiBound = 'true';

    const $root = $(root);
    $root.on(`change${NS}`, SELECTOR_PROP_INPUT, function () {
      setActiveForInput(root, this);
    });

    $root.find(`${SELECTOR_PROP_INPUT}:checked`).each(function () {
      setActiveForInput(root, this);
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR_ROOT).forEach(bind);
  }

  window.ProductFormPropUI = {
    bind,
    setActiveForInput,
    initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
